// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37D0-","label":"styles_label__1MPm3"};